import { Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import { NumberInput, TextInput } from "../../components";
import { useAccount } from "../../hooks";
import type { Card } from "../../models";
import { required, minValue, maxValue } from "ra-core";

export const CardForm = (): JSX.Element => {
    const { id } = useParams();
    const { id: accountId} = useAccount();
    return (
        <Grid container spacing={1} sx={{ width: "100%" }}>
            <TextInput<Card> source="accountId" sx={{ display: "none" }} defaultValue={accountId} />
            <TextInput<Card> source="lastFour" label="Number" disabled={!!id} validate={required()} />
            <TextInput<Card> source="name" disabled={!!id} validate={required()} />
            <NumberInput<Card> source="expMonth" disabled={!!id} validate={[required(), minValue(1), maxValue(12)]}/>
            <NumberInput<Card> source="expYear" disabled={!!id} validate={[required(), minValue(26), maxValue(100)]} />
            <NumberInput<Card> source="cvc" disabled={!!id} validate={[required(), minValue(100), maxValue(999)]} />
        </Grid>
    );
};

